export default "__VITE_ASSET__C1o1MwQN__"